<template>
  <transition name="fade" appear>
    <div class="progress">
      <p>Progress</p>
      <div class="bar" :class="[progressStep]">
        <div class="s1">
          <p>25%</p>
        </div>
        <div class="s2">
          <p>50%</p>
        </div>
        <div class="s3">
          <p>75%</p>
        </div>
        <div class="s4">
          <p>Complete</p>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  name: "Progress",
  data: function () {
    return {
      progressStep: "",
    };
  },
  mounted() {
    this.setProgress(this.$route.name);
  },
  watch: {
    "$route.name"(to, from) {
      this.setProgress(to);
    },
  },
  methods: {
    setProgress(to) {
      switch (to) {
        case "Home":
          this.progressStep = "";
          break;
        case "Interested In":
          this.progressStep = "p1";
          break;
        case "Ideal Benefits":
          this.progressStep = "p3";
          break;
        case "Recommendation":
          this.progressStep = "p4";
          break;
        default:
          this.progressStep = "p2";
          break;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.progress {
  display: flex;
  gap: 10px;
  font-size: 0.75rem;
  text-transform: uppercase;
  align-items: flex-end;  
  padding: 9px 0;
  font-family: 'Heading Pro';
  font-weight: bold;
  @media (max-width:899px) {
    width:100%;
  }
  @media (min-width:900px) {
    margin-left: auto;
  }
  > p {
    display:none;
    position: relative;
    top: 4px;
    @media (min-width:400px) {
      display:block;
    }
  }  
}
p {
  margin: 0;
  color: #fff;
}
.bar {
  display: grid;
  gap: 5px;
  grid-template-columns: repeat(4, 1fr);
  position: relative;
  width:100%;
  &:after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    background: linear-gradient(270deg, rgb(238, 62, 128) 0%, #d91d49 100%);
    height: 8px;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    transition: width 0.8s cubic-bezier(0.075, 0.82, 0.165, 1);
    box-shadow: 0 0 20px 10px rgba(238, 62, 128, 0);
    width: 0%;
  }
  p {}
  &.p1 {
    .s1 {
      p {
        color: #fff;
      }
    }
    &:after {
      box-shadow: 0 0 20px 10px rgba(238, 62, 128, 0.1);
      width: calc(25% - 4px);
    }
  }
  &.p2 {
    .s2 {
      p {
        color: #fff;
      }
    }
    &:after {
      box-shadow: 0 0 20px 10px rgba(238, 62, 128, 0.2);
      width: calc(50% - 2px);
    }
  }
  &.p3 {    
    .s3 {
      p {
        color: #fff;
      }
    }
    &:after {
      box-shadow: 0 0 20px 10px rgba(238, 62, 128, 0.3);
      width: calc(75% - 1px);
    }
  }
  &.p4 {
    .s4 p {
      color: #fff;
    }
    &:after {
      box-shadow: 0 0 20px 10px rgba(238, 62, 128, 0.41);
      width: 100%;
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
    }
  }
  > div {
    display:flex;
    flex-direction: column;
    justify-content: space-between;
    p {
      color: rgba(#fff, 0.4);
      text-align: center;
      padding: 2px 0;
      position: relative;
      z-index: 1;
      @media (min-width:460px) {
        padding:2px 10px;
      }
    }
    &:after {
      content: "";
      background: rgba(#fff, 0.4);
      height: 8px;
      width: 100%;
      display: block;
    }
    &:first-child:after {
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }
    &:last-child:after {
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
    }
  }
}
</style>